import { Outlet } from '@remix-run/react'

/**
 * Internal tools shell — child routes (e.g. staff) control width; nav can be full-bleed.
 */
export default function InternalLayout() {
  return (
    <div className="account-pages min-vh-100">
      <Outlet />
    </div>
  )
}
